"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.ModalProvider = exports.ModalContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const action_1 = require("./action");
const state_1 = require("./state");
const reducer_1 = require("./reducer");
exports.ModalContext = react_1.default.createContext(state_1.InitialState);
const ModalProvider = ({ children }) => {
    const [state, dispatch] = react_1.default.useReducer(reducer_1.reducer, state_1.InitialState);
    const close = react_1.default.useCallback(() => {
        dispatch({ type: action_1.ActionType.CloseModal });
    }, [dispatch]);
    const component = react_1.default.useMemo(() => {
        return state.modal({ close });
    }, [state.modal, close]);
    return ((0, jsx_runtime_1.jsxs)(exports.ModalContext.Provider, Object.assign({ value: { state, dispatch, close } }, { children: [(0, jsx_runtime_1.jsx)(react_modal_1.default, Object.assign({ isOpen: state.modal !== state_1.NOOPModal, onAfterOpen: () => null, onRequestClose: () => null, style: {}, contentLabel: "Example Modal" }, { children: component })), children] })));
};
exports.ModalProvider = ModalProvider;
function useModal() {
    const { state, dispatch, close } = react_1.default.useContext(exports.ModalContext);
    const open = react_1.default.useCallback((modal) => {
        dispatch({ type: action_1.ActionType.OpenModal, payload: modal });
    }, [dispatch]);
    return {
        close,
        modal: state.modal,
        open,
    };
}
exports.useModal = useModal;
